module.exports = __webpack_public_path__ + "static/one-838579f5e4da776569bd853564836c98.png";